import { useEffect, useState } from "react";
import styles from "./listSubscription.module.scss";
import PricingPlanCard from "../subscriptionPlan/SubscriptionCard/PricingPlanCard";
import { useAppDispatch, useAppSelector } from "src/page/store";
import { SubsList } from "src/page/plans/plansSlice";
import { Skeleton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { connectOrganisationToSubscriptionAction } from "src/page/childrenPlans/childrenPlansSlice";
import { fetchAccessibleListSubscription, fetchListSubscription } from "src/page/organisation/organisationSlice";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import swal from "sweetalert2";
import { getOrganisationDetail } from "src/network/graphql/organisationService";
import { OrganizationType } from "src/types/commonTypes";
import CircularLoader from "../UI/circularLoader/CircularLoader";
import { EMPTY_STRING } from "../constant/constant";

interface ListSubscriptionProp {
  handleClose: () => void;
  onSubmit: () => void;
  organisationId?: string;
  closeButton?: boolean;
  title?: string;
  accessible_Subscription?: boolean;
}

export default function ListSubscription({
  handleClose,
  onSubmit,
  organisationId,
  closeButton = true,
  title = "Subscriptions",
  accessible_Subscription = false
}: ListSubscriptionProp) {
  const dispatch = useAppDispatch();
  const { subscriptionList, subscriptionLoading, recentCreatedOrganisation } = useAppSelector(
    (state) => state.organisation
  );
  const { changeSubOrgsLoading } = useAppSelector((state) => state.childrenPlans);
  const [selectedPlan, setSelectedPlan] = useState<string>(EMPTY_STRING);
  const [subTitle, setSubTitle] = useState<string>(EMPTY_STRING);
  const [organisationType, setOrganisationType] = useState<OrganizationType | null>(null);

  useEffect(() => {
    async function fetchData() {
      if (organisationId) {
        try {
          const response = await getOrganisationDetail(organisationId);

          setOrganisationType(response.data.get_organisation?.type);

          const data = {
            limit: 100,
            page: 0,
            subscription_filter: {
              get_parent_subscription: true,
              organisation_type: response.data.get_organisation?.type,
              is_active: true
            }
          };

          accessible_Subscription
            ? await dispatch(fetchAccessibleListSubscription(data))
            : await dispatch(fetchListSubscription(data));
        } catch (err) {
          console.log(err);
        }
      }
    }
    fetchData();
  }, [dispatch, organisationId]);

  const handleSelectPlan = (subsId: string, subName: string) => {
    setSelectedPlan(subsId);

    swal
      .fire({
        title: `Are you sure! you want to add ${subName} subscription to this organisation?`,
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#1e293b",
        cancelButtonColor: "#1e293b",
        confirmButtonText: "Yes",
        customClass: {
          popup: "swal2-popup-custom"
        }
      })
      .then((result) => {
        if (result.isConfirmed) {
          const orgId = organisationId || recentCreatedOrganisation;

          dispatch(
            connectOrganisationToSubscriptionAction(orgId, subsId, () => {
              onSubmit();
            })
          );
        }
      });
  };

  const sliderSettings = {
    dots: true,
    infinite: subscriptionList?.size > 1,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    draggable: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerMode: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true
        }
      }
    ]
    // beforeChange: (current: number, next: number) => {
    //   const subscriptions = subscriptionList?.list || [];

    //   if (subscriptions[next]) {
    //     handleSelectPlan(subscriptions[next].subsId);
    //   }
    // }
  };

  useEffect(() => {
    switch (organisationType) {
      case "INDIVIDUAL":
        setSubTitle("To continue, you need to choose a NDIS funded SpendAble subscription");
        break;
      case "CORPORATE":
        setSubTitle("To continue, you need to choose a SpendAble subscription");
        break;
      default:
        setSubTitle(EMPTY_STRING);
    }
  }, [organisationType]);

  return (
    <div className={styles.referModalBox}>
      <main className={styles.referModalTop}>
        <form>
          <div className={styles.close}>
            <h5>{title}</h5>

            {closeButton && (
              <button onClick={handleClose} aria-label="Close modal">
                <CloseIcon onClick={handleClose} />
              </button>
            )}
          </div>
          {organisationId && organisationType && <p>{subTitle}</p>}
          {changeSubOrgsLoading ? (
            <div className={styles.loader}>
              <CircularLoader />
            </div>
          ) : (
            <>
              {EMPTY_STRING}
              {subscriptionLoading ? (
                <Skeleton variant="rounded" height={300} />
              ) : (
                <div className={styles.subscriptionList}>
                  <Slider {...sliderSettings}>
                    {subscriptionList?.list?.map((subscription: SubsList) => (
                      <div key={subscription.subsId} className={styles.sliderSlide}>
                        <div className={styles.sliderSlide}>
                          <PricingPlanCard
                            key={subscription.subsId}
                            title={subscription.title}
                            subTitle={subscription.subTitle}
                            description={subscription.description}
                            category={subscription.subscription_category}
                            // containerStyles={styles.pricingPlanContainer}
                            containerStyles={`${styles.pricingPlanContainer} ${
                              selectedPlan === subscription.subsId ? styles.activeSlide : EMPTY_STRING
                            }`}
                            titleStyles={styles.pricingPlanTitle}
                            subTitleStyles={styles.pricingPlanSubTitle}
                            buttonLabel={"Select"}
                            // buttonStyles={buttonStyles[subscription.subsId]}
                            onButtonClick={() => {
                              handleSelectPlan(subscription.subsId, subscription.title);
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              )}
            </>
          )}
        </form>
      </main>
      {/* <footer className={styles.referModalBottom}>
        <div className={styles.referModalBtn}>
          <Stack spacing={2} direction="row">
            {closeButton && (
              <Button className={styles.cancelBtn} variant="text" onClick={handleClose}>
                Cancel
              </Button>
            )}
            <Button className={styles.sendBtn} variant="contained" onClick={handleSubmit}>
              Submit
            </Button>
          </Stack>
        </div>
      </footer> */}
    </div>
  );
}
